import { z } from 'zod'

export const SUPPORTED_OWNERSHIP_IDS = {
  ALPHAMAP_OWNERSHIP_ENITITY: 'am-oen',
  ALPHAMAP_OWNERSHIP_PARCEL: 'am-opa',
} as const

export const ownershipIdsSchema = z
  .object({
    [SUPPORTED_OWNERSHIP_IDS['ALPHAMAP_OWNERSHIP_ENITITY']]: z.string().optional(),
    [SUPPORTED_OWNERSHIP_IDS['ALPHAMAP_OWNERSHIP_PARCEL']]: z.string().optional(),
  })
  .strict()
export type OwnershipIds = z.infer<typeof ownershipIdsSchema>

type SupportedOwnershipIds = (typeof SUPPORTED_OWNERSHIP_IDS)[keyof typeof SUPPORTED_OWNERSHIP_IDS]
type SupportedOwnershipIdsQueryParam = `id.${SupportedOwnershipIds}`

export type AMOwnershipQueryParams = {
  [key in SupportedOwnershipIdsQueryParam]?: string
}
